<template>
  <div>
    <div class="db-filter-modal">
      <div class="db-filter-title-text">Edit Detail Kegiatan Usaha Utama</div>
      <div class="db-filter-edit-form">
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Nama Kegiatan Usaha Utama</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select-full" v-model="editData.parent_id">
              <option v-for="(item, index) in $store.state.mdDatabaseStore.kbliData" :key="index" :value="item.id">{{
                item.desc }}</option>
            </select>
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Kode</div>
          <div class="db-filter-hiw-full">
            <input v-model="editData.kode" type="text" class="db-filter-hiw-text" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Deskripsi</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.desc" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Skala</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select" v-model="editData.skala_besar">
              <option>Tinggi</option>
              <option>Menengah Tinggi</option>
              <option>Menengah Rendah</option>
              <option>Rendah</option>
            </select>
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Catatan</div>
          <div class="db-filter-hiw-full">
            <input type="text" class="db-filter-hiw-text" v-model="editData.note" />
          </div>
        </div>
        <div class="db-filter-half-input-wrapper">
          <div class="db-filter-hiw-label">Status</div>
          <div class="db-filter-hiw-multiple">
            <select class="db-filter-hiw-select" v-model="editData.active">
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal">CANCEL</div>
          <div class="email-button" @click="update">CONFIRM</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../../../services/config'
export default {
  data() {
    return {
      editData: {
        parent_id: '',
        kode: '',
        desc: '',
        skala_besar: '',
        active: true,
        note: '',
      },
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    async update() {
      try {
        const update = this.editData
        update.update_by = this.$store.state.userid
        const url = `${api}/api/v1/kbli-sub`
        this.$store.commit('SET_GLOBAL_LOADING', true)

        const { data } = await axios({
          method: 'POST',
          url,
          data: this.editData,
        })

        if (data && data.status == 'success') {
          this.closeModal()
          this.$store.dispatch('mdDatabaseStore/onPageLoad', {
            name: 'currentContent',
            value: 'dkbli',
          })
          this.$store.commit('SET_GLOBAL_LOADING', false)
        }
      } catch (err) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(err, 'response.data.message', 'Error')
        )
        this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
